import { GrowthBook, GrowthBookProvider } from '@growthbook/growthbook-react'
import * as React from 'react'
import { osName } from 'react-device-detect'

import { GROWTHBOOK_API_HOST, GROWTHBOOK_CLIENT_KEY } from 'app/parameters'
import { store } from 'app/store/storage'

interface IGBProviderProps {
  children: React.ReactNode
  growthbookAttributeId: string
}

const GBProvider = ({ children, growthbookAttributeId }: IGBProviderProps) => {
  const os = React.useMemo(() => {
    const osNameTrimmed = osName?.toLowerCase().trim() || ''
    if (/windows/i.test(osNameTrimmed)) {
      return 'windows'
    } else if (/android/i.test(osNameTrimmed)) {
      return 'android'
    } else if (/iOS/i.test(osNameTrimmed)) {
      return 'ios'
    } else if (/mac OS/i.test(osNameTrimmed)) {
      return 'macos'
    } else if (/linux/i.test(osNameTrimmed)) {
      return 'linux'
    }
    return 'unknown'
  }, [])

  const growthbook = new GrowthBook({
    apiHost: GROWTHBOOK_API_HOST,
    clientKey: GROWTHBOOK_CLIENT_KEY,
    enableDevMode: true,
    subscribeToChanges: true,
    trackingCallback: (experiment, result) => {
      window.dataLayer?.push({
        event: 'experiment_viewed',
        event_category: 'experiment',
        experiment_id: experiment.key,
        variation_id: result.variationId,
        gb_user_id: store.sessionId,
      })
    },
  })

  React.useEffect(() => {
    growthbook.setAttributes({
      id: growthbookAttributeId,
      os,
    })
    void growthbook.loadFeatures()
  }, [growthbook, os, growthbookAttributeId])

  return <GrowthBookProvider growthbook={growthbook}>{children}</GrowthBookProvider>
}

export default GBProvider
